
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/library/queue",
      function () {
        return require("private-next-pages/library/queue.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/library/queue"])
      });
    }
  